export const ga4CatalogHost = 'https://google-analytics.documentation.coolblue.nl';
//# sourceMappingURL=ga4Catalog.js.map